"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    COSTUMER_SUPPORT_NUMBER: ()=>COSTUMER_SUPPORT_NUMBER,
    QUALTRICS_URL: ()=>QUALTRICS_URL,
    ROLE_ASSISTANT: ()=>ROLE_ASSISTANT,
    SALES_NUMBER: ()=>SALES_NUMBER
});
const QUALTRICS_URL = new URL('https://pricelineresearch.qualtrics.com/jfe/form/SV_3jXKJkoqkydiAjI');
const COSTUMER_SUPPORT_NUMBER = '1-773-922-6363';
const SALES_NUMBER = '1-833-881-0904';
const ROLE_ASSISTANT = 'assistant';
exports.COSTUMER_SUPPORT_NUMBER = __webpack_exports__.COSTUMER_SUPPORT_NUMBER;
exports.QUALTRICS_URL = __webpack_exports__.QUALTRICS_URL;
exports.ROLE_ASSISTANT = __webpack_exports__.ROLE_ASSISTANT;
exports.SALES_NUMBER = __webpack_exports__.SALES_NUMBER;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "COSTUMER_SUPPORT_NUMBER",
    "QUALTRICS_URL",
    "ROLE_ASSISTANT",
    "SALES_NUMBER"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
